import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import {
  Location,
  LocationByUser,
  LocationDetails
} from '../../../types/location/location';
import { viewTypeEnum } from '../../../constants/commonEnums';
import { OrganizationByUSer } from '../../../types/organizations/organizations';
import { IEvent } from '../../../types/events/eventsInterface';

const sliceLocation = createSlice({
  name: 'location',
  initialState: {
    eventToEdit: null,
    viewItems: viewTypeEnum.listView,
    locationsByUser: [],
    locationsAndOrganizationByUser: [],
    allLocations: [],
    currentLocation: { locationId: null, locationName: null },
    userLastLocations: [],
    isUpdateEvent: false
  } as {
    eventToEdit: null | IEvent;
    viewItems: string;
    locationsByUser: LocationByUser[];
    locationsAndOrganizationByUser: (LocationByUser | OrganizationByUSer)[];
    locationDetails?: LocationDetails;
    allLocations: Location[];
    currentLocation: {
      locationId: number | null;
      locationName: string | null;
    } | null;
    userLastLocations: { locationId: number; locationName: string }[] | null;
    isUpdateEvent: boolean;
  },
  reducers: {
    setEditEvent(state, action: PayloadAction<IEvent | null>) {
      state.eventToEdit = action.payload;
    },
    setIsUpdateEvent(state, action: PayloadAction<boolean>) {
      state.isUpdateEvent = action.payload;
    },
    setLocationsViewType: (
      state,
      {
        payload: { viewItems }
      }: PayloadAction<{
        viewItems: viewTypeEnum;
      }>
    ) => {
      state.viewItems = viewItems;
    },
    setLocationsByUser(state, action: PayloadAction<LocationByUser[]>) {
      state.locationsByUser = action.payload;
    },
    setLocationsDetails(state, action: PayloadAction<LocationDetails>) {
      state.locationDetails = action.payload;
    },
    setLocationsAndOrganizationsByUser(
      state,
      action: PayloadAction<(LocationByUser | OrganizationByUSer)[]>
    ) {
      state.locationsAndOrganizationByUser = action.payload;
    },
    setAllLocations(state, action: PayloadAction<Location[]>) {
      state.allLocations = action.payload;
    },
    setCurrentLocation(
      state,
      action: PayloadAction<{
        locationId: number;
        locationName: string;
      } | null>
    ) {
      state.currentLocation = action.payload;
    },
    setUserLastLocations(
      state,
      action: PayloadAction<
        | {
            locationId: number;
            locationName: string;
          }[]
        | null
      >
    ) {
      state.userLastLocations = action.payload;
    }
  }
});
export default sliceLocation.reducer;
export const selectedCurrentViewType = (state: RootState) =>
  state.location.viewItems;
export const selectedLocationsByUser = (state: RootState) =>
  state.location.locationsByUser;
export const selectedLocationsAndOrganizationsByUser = (state: RootState) =>
  state.location.locationsAndOrganizationByUser;
export const selectedAllLocations = (state: RootState) =>
  state.location.allLocations;
export const currentLocation = (state: RootState) =>
  state.location.currentLocation;
export const userLastLocations = (state: RootState) =>
  state.location.userLastLocations;
export const locationDetails = (state: RootState) =>
  state.location.locationDetails;
export const eventToEdit = (state: RootState) => state.location.eventToEdit;
export const isUpdateEvent = (state: RootState) => state.location.isUpdateEvent;
export const {
  setLocationsViewType,
  setLocationsByUser,
  setCurrentLocation,
  setAllLocations,
  setLocationsAndOrganizationsByUser,
  setUserLastLocations,
  setLocationsDetails,
  setEditEvent,
  setIsUpdateEvent
} = sliceLocation.actions;
